/**
 * Copyright 2019 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import environmentConfig from '../config/environment';
import logger from './logger';
import type { LogLevels } from './logger';
import { normalizeErrorForLogging } from './errorsHandling/normalizeErrorForLogging';
import { isServer } from '@/utils/isServer';

export async function crashReporter(
  message: string,
  type: string,
  error?: unknown,
  logLevel?: LogLevels,
) {
  const meta = {
    type,
    error: error ? await normalizeErrorForLogging(error) : undefined,
    isClient: !isServer,
  };

  const samplingRate = environmentConfig.REDUX_LOGGING_SAMPLE_RATE;
  if (logLevel) {
    logger[logLevel]({
      message,
      meta,
    });
  } else if (Math.random() < samplingRate) {
    logger.error({
      message,
      meta,
    });
  } else {
    logger.debug({
      message,
      meta,
    });
  }
}
